import ICidade from '../../interfaces/ICidade';
import ICidadeParaSelect from '../../interfaces/ICidadeParaSelect';

export const mapearCidadesParaSelect = (cidades: ICidade[]): ICidadeParaSelect[] =>
  cidades.map(({ id, nome, cepPadrao }) => ({
    value: id,
    label: nome,
    cepPadrao
  }));